import React, { Component } from "react";

export default class studentOrientation extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="container">
          <p>
            Student Orientation occurs in the few weeks (maybe 2) before your course start date. It is a nice event which you can take part
            in to get to know your fellow collegues.
          </p>
          <p>
            You can find more information about student orientation here -{" "}
            <a
              href="https://grad.uga.edu/index.php/incoming-students/orientation-for-international-students/"
              target={"_blank"}
              rel={"noreferrer"}
            >
              Info
            </a>{" "}
          </p>
          <p>
            You can also check out -{" "}
            <a href="https://isa.uga.edu/" target={"_blank"} rel={"noreferrer"}>
              Indian Student Association (ISA){" "}
            </a>{" "}
          </p>
        </div>
      </React.Fragment>
    );
  }
}
